import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const chevronBox: SxStyle = {
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: (p) => p.palette.grey[200],
  height: 'fit-content',
  borderRadius: (p) => p.spacing(0.5),
};

export const scrollbar: SxStyle = { height: (p) => p.spacing(32) };
